import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicFeaturesGrid3 from '../../RifoDesign/EpicFeaturesGrid3/epic.features.grid3.vue';
import { FeatureGridItem } from '../../RifoDesign/EpicFeaturesGrid3/epic.features.grid3.component';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import EpicGraphicTextSection from '../../RifoDesign/EpicGraphicTextSection/epic.graphic.text.section.vue';
import { CommonConfig } from '../../configs/config.common';
@Component({
    components: {
        'layout': EpicStandardLayout,
        EpicHeaderBannerText,
        EpicFeaturesGrid3,
        EpicGraphicTextSection
    }
})
export default class EpicHomeLoan extends Vue {
    public configs = new CommonConfig();
    public featureGridList: FeatureGridItem[] = [];
    public bgImg = `${this.configs.rifoDesignAssetsUrl}/epic-home-loan/loan-bottom-bg.png`;
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg0.jpg`;
    public created() {
        this.featureGridList = [{
            img: `${this.configs.rifoDesignAssetsUrl}/epic-home-loan/home-loan-feature-1.png`,
            tagline: 'Lowest Rate',
            description: 'We do our best to get the lowest rate to help you save money'
        }, {
            img: `${this.configs.rifoDesignAssetsUrl}/epic-home-loan/home-loan-feature-2.png`,
            tagline: 'Professional Team',
            description: 'Our professional financial specialists offer best options'
        }, {
            img: `${this.configs.rifoDesignAssetsUrl}/epic-home-loan/home-loan-feature-3.png`,
            tagline: 'Fast & Easy',
            description: 'We make loan approval process fast and effective'
        }];
    }

    public mounted() {
    }
}
